module.exports = __webpack_public_path__ + "media/qr-code.48df0515.mp4";